<template>
  <aside class="risk-list">
    <div class="list-head">
      <div class="title-row">
        <span class="title">龙头监控</span>
        <span class="badge">{{ leaders.length }}</span>
        <button type="button" class="add-btn" title="待接入" disabled>+</button>
      </div>
      <div class="sub">外部名单 · 高度变化自动退池（与观察池同源）</div>
    </div>

    <div class="filters">
      <el-select v-model="statusFilter" size="mini" class="status-sel" disabled>
        <el-option label="全部状态" value="all" />
      </el-select>
      <label class="chk"><input v-model="onlyNew" type="checkbox" disabled /> 仅本次新增</label>
      <label class="chk"><input v-model="onlyAnomaly" type="checkbox" disabled /> 仅数据异常</label>
    </div>

    <div v-if="loading" class="empty">加载监控池…</div>
    <div v-else-if="!leaders.length" class="empty">当前日期无监控池龙头</div>
    <ul v-else class="items">
      <li
        v-for="(row, idx) in displayRows"
        :key="row.leaderId || row.code"
        class="item"
        :class="{ on: isSelected(row), [row.stageTone]: true }"
        @click="$emit('select', row)"
      >
        <div class="row1">
          <div class="id-block">
            <span class="name">{{ row.name || '—' }}</span>
            <span class="code">{{ row.code || '—' }}</span>
          </div>
          <span class="pct" :class="pctClass(row.changePct)">{{ formatPct(row.changePct) }}</span>
          <span class="stage" :class="row.stageTone">{{ row.stageLabel }}</span>
        </div>
        <div class="row2">
          <span>周期 {{ idx + 1 }}</span>
          <span v-if="row.entryDate">入池 {{ shortDate(row.entryDate) }}</span>
          <span v-if="row.daysInMonitor != null">在池 {{ row.daysInMonitor }} 日</span>
          <span class="demo-tag">布局演示</span>
        </div>
      </li>
    </ul>
  </aside>
</template>

<script>
import riskDemo from '@/data/leaderCommandCenter/riskModeDemo.json'

export default {
  name: 'RiskLeaderList',
  props: {
    leaders: { type: Array, default: () => [] },
    selectedId: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      statusFilter: 'all',
      onlyNew: false,
      onlyAnomaly: false
    }
  },
  computed: {
    displayRows() {
      const presets = riskDemo.stagePresets || []
      return (this.leaders || []).map((l, i) => {
        const p = presets[i % presets.length] || riskDemo.defaultDetail
        const stageId = p.activeStageId || 'continuation'
        let stageTone = 'tone-cont'
        if (stageId === 'divergence') stageTone = 'tone-div'
        if (stageId === 'ebb') stageTone = 'tone-ebb'
        return Object.assign({}, l, {
          stageLabel: p.stageLabel || riskDemo.meta.defaultStage,
          stageTone
        })
      })
    }
  },
  methods: {
    isSelected(row) {
      const id = row.leaderId || row.code
      return id && id === this.selectedId
    },
    formatPct(v) {
      if (v == null || !Number.isFinite(Number(v))) return '—'
      const n = Number(v)
      const sign = n > 0 ? '+' : ''
      return sign + n.toFixed(2) + '%'
    },
    pctClass(v) {
      if (v == null || !Number.isFinite(Number(v))) return 'flat'
      if (Number(v) > 0) return 'up'
      if (Number(v) < 0) return 'down'
      return 'flat'
    },
    shortDate(d) {
      const s = String(d || '')
      if (s.length >= 10) return s.slice(5, 10)
      return s
    }
  }
}
</script>

<style scoped lang="scss">
.risk-list {
  background: #fff;
  border: 1px solid #d7e4f6;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.list-head {
  padding: 12px 12px 8px;
  border-bottom: 1px solid #e8eef8;
}
.title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.title { font-size: 15px; font-weight: 800; color: #1a2b3c; }
.badge {
  background: #1a73e8;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 7px;
}
.add-btn {
  margin-left: auto;
  width: 26px;
  height: 26px;
  border: 1px solid #d7e4f6;
  background: #f7faff;
  border-radius: 6px;
  color: #7b93b5;
  cursor: not-allowed;
}
.sub { margin-top: 4px; font-size: 11px; color: #90a4c0; }
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #e8eef8;
}
.status-sel { width: 110px; }
.chk {
  font-size: 11px;
  color: #7b93b5;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  opacity: 0.75;
}
.items {
  list-style: none;
  margin: 0;
  padding: 8px;
  overflow: auto;
  flex: 1;
}
.item {
  border: 1px solid #e8eef8;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  background: #fafcff;
  transition: border-color 0.15s, box-shadow 0.15s;
  &:hover { border-color: #b8d0f0; }
  &.on {
    border-color: #1a73e8;
    box-shadow: 0 0 0 1px rgba(26, 115, 232, 0.2);
    background: #f3f8ff;
    .name { color: #1a73e8; }
  }
  &.tone-ebb {
    background: #fff5f5;
  }
}
.row1 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.id-block {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.name {
  font-size: 13px;
  font-weight: 700;
  color: #1a2b3c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.code { font-size: 11px; color: #90a4c0; }
.pct {
  font-size: 13px;
  font-weight: 700;
  min-width: 62px;
  text-align: right;
  &.up { color: #e24b4b; }
  &.down { color: #1aae6f; }
  &.flat { color: #7b93b5; }
}
.stage {
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  &.tone-div { color: #1a73e8; }
  &.tone-cont { color: #e67e22; }
  &.tone-ebb { color: #c62828; }
}
.row2 {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: #90a4c0;
}
.demo-tag { color: #1a73e8; }
.empty {
  padding: 24px 12px;
  text-align: center;
  font-size: 12px;
  color: #90a4c0;
}
</style>
